import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Icon} from "..";
import {Exhibit} from "../../Exhibit";
import {Grid} from "../../Grid";
import {extendedWidth} from "timvir/core";
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    path: "path",
    svg: "svg",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Icon"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "<Icon>"
      }), " component is used to display a single, square component. Usually a ", _jsx(_components.code, {
        children: "<svg>"
      }), ", up to ~80px in size."]
    }), "\n", _jsx(Exhibit, {
      children: _jsx("div", {
        style: {
          padding: 40,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%"
        },
        children: _jsx("div", {
          style: {
            width: 120
          },
          children: _jsx(Icon, {
            descriptor: {
              name: "ArrowRight",
              instances: [{
                size: 12,
                Component: () => _jsx(_components.svg, {
                  width: "12px",
                  height: "12px",
                  viewBox: "0 0 12 12",
                  children: _jsx(_components.path, {
                    fill: "#444",
                    d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
                  })
                })
              }]
            }
          })
        })
      })
    }), "\n", _jsxs(_components.h2, {
      children: ["In a ", _jsx(_components.code, {
        children: "<Grid>"
      })]
    }), "\n", _jsxs(Grid, {
      className: extendedWidth,
      style: {
        margin: 24,
        gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
        gridGap: 24
      },
      children: [_jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "NavigationArrowLeft",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      }), _jsx(Icon, {
        descriptor: {
          name: "ArrowRight",
          instances: [{
            size: 12,
            Component: () => _jsx(_components.svg, {
              width: "12px",
              height: "12px",
              viewBox: "0 0 12 12",
              children: _jsx(_components.path, {
                fill: "#444",
                d: "M1.98 2.1L5.88 6 1.98 9.9 4.08 12 10.08 6 4.08 0 1.98 2.1z"
              })
            })
          }]
        }
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
